<template>
  <div class="third ziXunLanMu">
    <div class="third-formOne">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>
          <span class="left-back-content">{{ talNname }}资讯栏目</span>
        </div>
        <div class="btn-right">
          <el-button @click="resetForm" class="btn-two" type="default"
            >重置</el-button
          >
          <el-button
            @click="commit"
            class="btn-two"
            type="primary"
            v-el-disabel-repeat-click
            >保存</el-button
          >
        </div>
      </div>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="86px"
        @validate="validateValue"
        :show-message="false"
      >
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">基本信息</span>
              </div>
            </div>
            <div class="one-list">
              <el-form-item label="资讯栏目名称" prop="showName">
                <el-input
                  class="list-input"
                  v-model.trim="ruleForm.showName"
                  :maxlength="6"
                  placeholder="请输入"
                ></el-input>
                <span></span>
              </el-form-item>
              <el-form-item label="资讯来源" prop="information">
                <el-radio-group v-model="ruleForm.information">
                  <el-radio label="1">公众号</el-radio>
                  <el-radio label="2">API服务</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- <el-form-item label="顺序" prop="order">
                <el-input
                  class="list-input"
                  :maxlength="20"
                  v-model.trim="ruleForm.order"
                  placeholder="请输入正整数"
                  oninput="value=value.replace(/[^\d.]/g,'')"
                  :disabled="false"
                ></el-input>
              </el-form-item> -->
              <el-form-item label="顺序" prop="order">
                <el-input-number
                  class="list-input baseData-input-number"
                  :controls="false"
                  v-model="ruleForm.order"
                  :min="0"
                  :max="9999"
                  step-strictly
                  placeholder="请输入正整数"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="查看权限" prop="viewRole">
                <el-radio-group v-model="ruleForm.viewRole">
                  <el-radio label="0">未登录可查看</el-radio>
                  <el-radio label="1">登录后才可查看</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="查看角色">
                <!-- <el-radio-group v-model="ruleForm.openAll">
                  <el-radio label="1">展示</el-radio>
                  <el-radio label="2">隐藏</el-radio>
                </el-radio-group> -->
                <template v-if="ruleForm.viewRole == 1">
                  <el-tag
                    style="margin: 0 4px"
                    v-for="tag in roleTags"
                    :key="tag.id"
                    @close="handleRoleClose(tag)"
                    closable
                    >{{ tag.name }}</el-tag
                  >
                  <el-button
                    style="height: 24px"
                    type="default"
                    icon="el-icon-plus"
                    @click="addTags('role')"
                    >新增</el-button
                  >
                </template>

                <span v-else style="font-size: 12px;color:#999999"
                  >所有用户可查看此资讯栏目，同时游客模式下用户可查看此栏目的信息列表及信息详情</span
                >
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <el-dialog
      class="serviceListTree"
      title="新增授权角色"
      :visible.sync="roleTreeDialogVisible"
      :close-on-click-modal="false"
      width="30%"
      v-el-drag-dialog
    >
      <el-tree
        :data="roleTree"
        show-checkbox
        default-expand-all
        node-key="roleId"
        ref="roleTree"
        highlight-current
        :props="{
          children: 'children',
          label: 'roleName',
        }"
      ></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleTreeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getCheckedKeys('roleTree')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <notice-modal
      :noticeModalVisible="noticeModal"
      @noticeModalClose="closeNotice"
      @noticeModalAgree="agreeNotice"
      :noticeTitle="noticeTitle"
      :noticeSpec="noticeSpec"
      :noticeType="noticeType"
      :btnAgree="agreeContent"
      :noticeContent="noitceContent"
    >
    </notice-modal>
    <!-- <addOfficalAccounts
      :addModalVisible="addModalVisible"
      @closeAddModal="closeAddModal"
      :choosedList="currentTableData"
      @addData="addData"
    ></addOfficalAccounts> -->
  </div>
</template>

<script>
import {
  newsSectionConfigSave,
  newsSectionConfigUpdate,
} from "@/store/appconfig/inforMationConfig"; //我的;
import Sortable from "sortablejs";
// import addOfficalAccounts from '../component/addOfficalAccounts'
import { uniqBy } from "lodash";
import { getStore } from "@/utils/store";
export default {
  name: "formSeven",
  props: ["rowId"],
  data() {
    const blurText = async (rule, value, callback) => {
      const boolean = new RegExp("^[1-9][0-9]*$").test(value); // console.log(boolean)
      if (!boolean) {
        callback(new Error("请输入正整数"));
      }
    };
    return {
      currentName: "",
      countNum: 1, //用于显示第一个错误
      addModalVisible: false,
      cpRowId: this.rowId,
      //   &********弹框******************************
      agreeNotice: {},
      noticeType: 1, // 提示类型
      agreeContent: "确定", // 提示弹窗确认按钮内容
      noticeTitle: "提示", // 提示
      noitceContent: "确定启用删除吗？", // 提示信息
      noticeModal: false, // 提示弹窗
      noticeSpec: "", // 标红提示
      //   &**************************************
      ruleForm: {
        id: "",
        showName: "",
        information: "1",

        order: undefined,
        viewRole: "0",
      },
      information1: "",
      rules: {
        showName: [
          { required: true, message: "请输入资讯栏目名称", trigger: "blur" },
        ],
        information: [
          { required: true, message: "请选择资讯来源", trigger: "blur" },
        ],
        viewRole: [
          { required: true, message: "请选择查看权限", trigger: "blur" },
        ],
        order: [
          { required: true, message: "请输入顺序", trigger: "blur" },
          //   { validator: blurText, trigger: "blur" }, //表单验证的时候会调用的方法
        ],
      },
      currentTableData: [],
      roleTags: [], // 角色标签
      roleTreeDialogVisible: false, // role弹窗
      roleTree: [],
      talNname: "新增",
      rowData: {},
      apiServeDataId: "",
      id: "",
    };
  },
  components: {
    // addOfficalAccounts
  },
  created() {
    // document.body.ondrop = function (event) {
    //   event.preventDefault();
    //   event.stopPropagation();
    // };
    // this.itemDetail()
    // this.serviceBusDetail();
    let result = getStore({ name: "goRowData", type: "session" });

    console.log(result);
    if (result != null) {
      this.rowData = result;
      this.talNname = "编辑";
      this.ruleForm.showName = result.name;
      this.ruleForm.information = result.sourceType=="OFFICIAL_ACCOUNT"?'1':'2';
      this.information1 = result.sourceType !=="OFFICIAL_ACCOUNT" &&  result.sourceType !=="API"? result.sourceType : "" //将当前的api分类缓存一个在本地,如果点击保存时选择的还是api(2),那么就用这个缓存的分类
      this.ruleForm.order = result.sortOrder;
      this.ruleForm.viewRole = result.needLogin + "";
      this.apiServeDataId = result.apiServeDataId;
      this.id = result.id;
    } else {
      this.talNname = "新增";
    }
    this.getRolelist(); // 获取使用角色
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.rowDrop();
    // });
  },
  watch: {
    rowId() {
      this.cpRowId = this.rowId;
    },
    // currentTableData() {
    //   this.$nextTick(() => {
    //     this.rowDrop()
    //   })
    // }
  },
  methods: {
    async getRolelist() {
      try {
        const res2 = await this.$store.dispatch("getServiceRoleList");
        if (res2.data.status === 1000) {
          const { result } = res2.data;
          this.roleTree = result;
        }
        // debugger
        let childrenList = []; // 整理角色列表 去除一级 只留二级数据
        this.roleTags = [];
        this.roleTree.forEach((element) => {
          element.children.forEach((ele) => {
            childrenList.push(ele);
          });
        });
        if (this.rowData.viewPermission) {
          this.rowData.viewPermission.split(",").forEach((element) => {
            let role = childrenList.map((item) => {
              if (item.roleId === element) {
                return {
                  id: item.roleId,
                  name: item.roleName,
                };
              }
            });
            role = role.filter((item) => item);
            role.forEach((ele) => this.roleTags.push(ele));
            console.log(this.roleTags);
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    handleRoleClose(tag) {
      console.log(tag);
      const { roleTags } = this;
      this.roleTags = roleTags.filter((item) => item !== tag);
    },
    addTags(type) {
      this.roleTreeDialogVisible = true;
      this.roleOrlabel = true;
      if (this.roleTags.length > 0) {
        const keys = this.roleTags.map((item) => item.id);
        // console.log(keys)
        this.$nextTick(() => {
          this.$refs.roleTree.setCheckedKeys(keys);
        });
      }
    },
    getCheckedKeys(refName) {
      const getNode = this.$refs[refName].getCheckedNodes();
      if (this.roleOrlabel) {
        const selectArr = getNode.map((item) => {
          if (item.roleId) {
            return {
              name: item.roleName,
              id: item.roleId,
            };
          }
        });
        this.roleTags = selectArr.filter((item) => item);
        this.roleTreeDialogVisible = false;
      }
    },
    //返回首页
    goBack() {
      this.$emit("fatherMethod", "adhibitionJPG");
    },
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    // 提交表单
    commit() {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.ruleForm.validate((valid) => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            let result = getStore({ name: "goRowData", type: "session" });
            if (result != null) {
              this.updateData();
              return;
            }
            this.addData();
          } else {
            return false;
          }
        });
      });
    },
    //表单重置
    resetForm() {
      this.$refs.ruleForm.clearValidate();
      let result = getStore({ name: "goRowData", type: "session" });

      console.log(result);
      if (result != null) {
        console.log(result);
        this.rowData = result;
        this.ruleForm.showName = result.name;
        this.ruleForm.information = result.sourceType=="OFFICIAL_ACCOUNT"?'1':'2';
        this.information1 = result.sourceType !=="OFFICIAL_ACCOUNT" &&  result.sourceType !=="API"? result.sourceType : ""
        this.ruleForm.order = result.sortOrder;
        this.ruleForm.viewRole = result.needLogin + "";
        this.getRolelist(); // 获取使用角色
      } else {
        (this.ruleForm.showName = ""),
          (this.ruleForm.information = "1"),
          (this.ruleForm.order = undefined),
          (this.ruleForm.viewRole = "0");
        this.roleTags = [];
      }

      //   this.$nextTick(() => {
      //     this.itemDetail();
      //   });
    },
    async updateData() {
      console.log(this.roleTags.map((item) => item.id).join(","));
      console.log(this.ruleForm.information);
      console.log(this.information1);
      let type =''
      if (this.ruleForm.information=='2' && this.information1) {
          type = this.information1
      }else if (this.ruleForm.information=='2') {
          type = 'API'
      } else {
          type = 'OFFICIAL_ACCOUNT'
      }
    //   return
      const aaa = {
        id: this.id,
        name: this.ruleForm.showName,
        sourceType: type,//编辑时候取用缓存,因为可能已经为该项api配置了详细接口
        sortOrder: this.ruleForm.order,
        needLogin: Number(this.ruleForm.viewRole),
        viewPermission: this.roleTags.map((item) => item.id).join(","),
        apiServeDataId: this.apiServeDataId,
        createTime: "",
        updateTime: "",
      };
      console.log(aaa, "请求参数");
      try {
        const {
          data: { result, msg, status },
        } = await newsSectionConfigUpdate({
          ...aaa,
        });
        if (status === 1000) {
          this.$message.success("操作成功");
          this.goBack();
          console.log("结果", result);
          return;
        }
        return this.$message.error(msg);
      } catch (err) {
        console.log(err);
      }
    },
    deleteRowConfirm(rowData, index) {
      // this.agreeNotice = () => {
      //   this.noticeModal = false
      //   this.deleteRow(index)
      // }
      // this.noticeModal = true
      this.deleteRow(index);
    },
    deleteRow(index) {
      this.currentTableData.splice(index, 1);
    },
    updateStatus(rowData, index) {
      if (rowData.openStatus === "1") {
        this.$set(this.currentTableData[index], "openStatus", "2");
        return;
      }
      this.$set(this.currentTableData[index], "openStatus", "1");
    },
    async addData() {
      console.log(this.roleTags.map((item) => item.id).join(","));
      try {
        const aaa = {
          id: this.id,
          name: this.ruleForm.showName,
          sourceType: this.ruleForm.information=='1'?'OFFICIAL_ACCOUNT':'API',//在新增情况下如果选中接口来源于api,则默认传"API"
          sortOrder: this.ruleForm.order,
          needLogin: Number(this.ruleForm.viewRole),
          viewPermission: this.roleTags.map((item) => item.id).join(","),
          apiServeDataId: this.apiServeDataId,
          createTime: "",
          updateTime: "",
        };
        console.log(aaa, "请求参数");
        //   return;
        const {
          data: { result, msg, status },
        } = await newsSectionConfigSave({
          ...aaa,
        });
        if (status === 1000) {
          this.$message.success("操作成功");
          this.goBack();
          console.log("结果", result);
          return;
        }
        return this.$message.error(msg);
      } catch (err) {
        console.log(err);
      }
    },
    closeAddModal() {
      this.addModalVisible = false;
    },
    openAddDialog() {
      this.addModalVisible = true;
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.currentTableData.splice(oldIndex, 1)[0];
          _this.currentTableData.splice(newIndex, 0, currRow);
          const newList = [..._this.currentTableData];
          _this.currentTableData = [];
          _this.$nextTick(() => {
            _this.currentTableData = [...newList];
          });
          console.log("_this.currentTableData", _this.currentTableData);
        },
      });
    },
    async itemDetail() {
      console.log("this.cpRowId", this.cpRowId);
      try {
        const {
          data: { result, msg, status },
        } = await itemDetailPort({
          id: this.rowId,
        });
        if (status === 1000) {
          this.currentName = result.itemName;
          this.ruleForm = result;
          this.currentTableData = [...result.serviceList];
          console.log("结果", result);
          return;
        }
        return this.$message.error(msg);
      } catch (err) {
        console.log(err);
      }
    },
    // 关闭弹窗
    closeNotice() {
      this.noticeModal = false;
    },
    // 复制地址
    copyUrl(url, params) {
      let copy = (e) => {
        e.preventDefault();
        e.clipboardData.setData("text/plain", url + params);
        this.$message.success("操作成功");
        document.removeEventListener("copy", copy);
      };
      document.addEventListener("copy", copy);
      document.execCommand("copy");
    },
    // 改变index页面的component的值
    changeComponent() {
      this.$emit("changeComponent", "homePage");
    },
  },
};
</script>
<style lang="scss">
.ziXunLanMu {
  .multi-rows,
  .single-row {
    display: inline-block;
    font-size: 12px;
    padding-left: 8px;
    color: #828d9a;
  }
  .add-row {
    margin-bottom: 15px;
    font-size: 12px;
    color: rgb(46, 63, 87);
    .el-button {
      margin-left: 0 !important;
      margin-right: 10px;
    }
  }
  .rows-copy {
    padding-left: 8px;
    color: #2d8cf0;
    cursor: pointer;
  }
  .single-row {
    min-width: 292px;
  }
  .row-goto {
    color: #2d8cf0;
    cursor: pointer;
  }
  .multi-rows {
    width: 676px;
  }
  .serviceListTree {
    ::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .el-dialog__header {
      border-bottom: 1px solid #d9d9d9;
    }
    .el-dialog__footer {
      border-top: 1px solid #d9d9d9;
    }
    .el-dialog__body {
      height: 400px;
      overflow-y: auto;
    }
  }
  .baseData-input-number {
    .el-input__inner {
      text-align: left;
    }
  }
}
</style>
